export { InlineMessageIcon } from './inline-message-icon';
export type { TInlineMessageIconProps } from './inline-message-icon';
